(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('DayOffDialogController', function ($uibModalInstance, DayOff, item) {
            var vm = this;
            vm.item = item;

            vm.save = function () {
                var request = vm.item.id
                    ? DayOff.update({id: vm.item.id}, vm.item).$promise
                    : DayOff.save(vm.item).$promise;
                return request.then(function (result) {
                    $uibModalInstance.close(result);
                });
            };

            vm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        });
})();
